// This is important, without this webpack won't resolve asset paths correctly
import './webpack-public-path';
import React from 'react';
import { render } from 'react-dom';
import { defaultsDeep } from 'lodash';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

import { getEnvironmentState } from './state-helpers';

import { loadResourceBundles } from './i18n/i18n';
import makeStore from './store';
import EventManager from '@shop/lib-eventmanager';
import AppContainer from './containers/app';

import defaultState from './default-state.json';

export const init = (instanceId, elementSelector, serverState = {}, locale) => {
	const element = document.querySelector(elementSelector);
	const envState = getEnvironmentState();

	const storeState = defaultsDeep(Object.assign({}, serverState),
		envState,
		defaultState
	);
	const store = makeStore(storeState, instanceId);

	const i18nInstance = i18n.createInstance();

	i18nInstance.init({
		lng: locale
	}, (err) => {
		// istanbul ignore if
		if (err) throw err;
		loadResourceBundles(i18nInstance, locale)
			.then(() => {
				render(
					<I18nextProvider i18n={ i18nInstance }>
						<Provider store={store}>
							<AppContainer />
						</Provider>
					</I18nextProvider>,
					element
				);
			});
	});
};

// istanbul ignore next
EventManager.trigger('bbmx-comparison-selector-mx-pdp:gvp-init', init);



// WEBPACK FOOTER //
// ./client/index.js